import { render } from "./CustomHTML.vue?vue&type=template&id=b94c223e&scoped=true"
import script from "./CustomHTML.vue?vue&type=script&lang=ts"
export * from "./CustomHTML.vue?vue&type=script&lang=ts"

import "./CustomHTML.vue?vue&type=style&index=0&id=b94c223e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b94c223e"

export default script